export default "__VITE_ASSET__D0JmEFCE__";